'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMetadata = exports.createMetadata = exports.fetchMetadata = exports.deserializeMetadata = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var deserializeMetadata = exports.deserializeMetadata = function deserializeMetadata() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeMetadata)(data) : (0, _everydayhero.deserializeMetadata)(data);
};

var fetchMetadata = exports.fetchMetadata = function fetchMetadata() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchMetadata)(params) : (0, _everydayhero.fetchMetadata)(params);
};

var createMetadata = exports.createMetadata = function createMetadata() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.isJustGiving)() ? (0, _justgiving.createMetadata)(params) : (0, _everydayhero.createMetadata)(params);
};

var updateMetadata = exports.updateMetadata = function updateMetadata() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.isJustGiving)() ? (0, _justgiving.updateMetadata)(params) : (0, _everydayhero.updateMetadata)(params);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/metadata/index.js
// module id = 1325
// module chunks = 0